import React from 'react';
// import PropTypes from 'prop-types';
import {  styled  } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
//import StarBorderIcon from '@material-ui/icons/StarBorder';

import StopIcon from '@material-ui/icons/Stop';

import Box from '@material-ui/core/Box';


const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: 'RGBA(0,53,89,1)',
  },
});



// function IconContainer(props:any) {
//   const { value, ...other } = props;
//   return <span {...other}>{customIcons[1].icon}</span>;
//  color: 'RGBA(0,53,89,1)
// }

// IconContainer.propTypes = {
//   value: PropTypes.number.isRequired,
// };

//const styles = useStyles();

export type TemplateWarScoreProps = {
  // template: TemplateEntityV1beta3;
  value?: any;
  maxValue?: any;

}

// const getTemplateWarScoreProps = (
//   template: TemplateEntityV1beta3,
// ): TemplateProps & { key: string } => {
//   return {


//   };
// };




export const TemplateWarScore = ({ value, maxValue }: TemplateWarScoreProps) => {

  // const useStyles = makeStyles(() => ({
  //   squareActiveIcon: {
  //     height: '12px',
  //     width: '12px',
  //     marginTop: '-25px',
  //     marginLeft: '125px',
  //     backgroundColor: '#003F5F'
  //   },
  // }

  // ));


  console.log('max value ', value, maxValue)

  // const classes = useStyles();

  return (
    <div>
      <Box data-testid='box_element' component="fieldset" mb={3} borderColor="transparent">
        {/* <Typography component="legend">Custom empty icon</Typography> */}
        <StyledRating data-testid='styleRating'
          name="customized-color"
          defaultValue={value}
          //getLabelText={(value) => `${value} Heart${value !== 1 ? 's' : ''}`}
          //precision={0.5}
          max={maxValue || 0}
          icon={<StopIcon fontSize="inherit" />}
        />
       
      </Box>
    </div>
  );
}